import { render, staticRenderFns } from "./addAcc.vue?vue&type=template&id=93f84c8c&scoped=true"
import script from "./addAcc.vue?vue&type=script&lang=js"
export * from "./addAcc.vue?vue&type=script&lang=js"
import style0 from "./addAcc.vue?vue&type=style&index=0&id=93f84c8c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93f84c8c",
  null
  
)

export default component.exports